// eslint-disable-next-line import-x/named -- HttpStatusCode is a valid axios export; false positive from .d.cts resolution
import { HttpStatusCode } from 'axios';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import ErrorPage from '~components/errorBoundary/errorPage';
import ErrorType from '~components/errorBoundary/errorType';

const RouteErrorElement = () => {
	const error = useRouteError();
	const { t } = useTranslation();
	const navigate = useNavigate();

	if (isRouteErrorResponse(error)) {
		if (error.status === HttpStatusCode.Unauthorized) {
			return (
				<ErrorPage
					type={ErrorType.NotAuthorized}
					onAction={() => navigate('/', { replace: true })}
				/>
			);
		}

		if (error.status === HttpStatusCode.Forbidden) {
			return (
				<ErrorPage type={ErrorType.Forbidden} onAction={() => navigate('/', { replace: true })} />
			);
		}

		if (error.status === HttpStatusCode.NotFound) {
			return <ErrorPage type={ErrorType.NotFound} onAction={() => navigate(-1)} />;
		}
	}

	console.error('Unhandled route error:', error);

	return (
		<ErrorPage
			type={ErrorType.Other}
			description={error instanceof Error ? error.message : t('unknownError', { ns: 'errors' })}
			onAction={() => navigate(0)}
		/>
	);
};

export default RouteErrorElement;
